import styled from 'styled-components';

export const OptionGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const OptionButton = styled.button<{ $selected: boolean; $tone?: string; $error?: boolean }>`
  cursor: pointer;
  min-width: 96px;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 24px;
  background: ${({ theme, $selected, $tone }) => {
    if (!$selected) {
      return theme.palette.common.white;
    }
    return $tone || theme.palette.grey[700];
  }};
  color: ${({ theme, $selected }) => ($selected ? theme.palette.common.white : theme.palette.text.primary)};
  border: 1px solid
    ${({ theme, $selected, $tone, $error }) => {
      if ($error) {
        return theme.palette.error.main;
      }
      if ($selected) {
        return $tone || theme.palette.grey[700];
      }
      return theme.palette.grey[300];
    }};

  &:hover {
    border-color: ${({ theme, $tone }) => $tone || theme.palette.primary.main};
  }
`;

export const ErrorText = styled.p`
  margin: 4px 0 0;
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 12px;
  line-height: 16px;
`;
